function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.63 9.32l-.89.89a.58.58 0 01-.41.18.62.62 0 01-.41-.18l-7-7-7 7a.56.56 0 01-.82 0l-.89-.89a.56.56 0 010-.82L8.53.18a.56.56 0 01.82 0l8.32 8.32a.56.56 0 01-.04.82z"
});

var SvgAccordionHeaderCollapse = function SvgAccordionHeaderCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 17.82 10.39"
  }, props), _ref);
};

export default SvgAccordionHeaderCollapse;